import {Box, Button, Container} from "@mui/material";
import useScrollToTop from "../../hooks/useScrollToTop";
import HeroImage from "../../components/HeroImage";
import Footer from "../../components/Footer";
import useCallDataApi from "../../hooks/data";
import {useEffect, useState, useContext} from "react";
import Loading from "../../components/Loading";
import {useHistory, useParams} from "react-router-dom";
import DrawerAppbar from "../../components/DrawerAppbar";
import {useTranslation} from "react-i18next";
import ConfigContext from "../../context/ConfigContext";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import logo from '../../assets/shared/jet-adventure-logo-white-01.png'


const AdventureCard = () => {

    useScrollToTop()
    const {t} = useTranslation()
    const {language} = useContext(ConfigContext)
    const history = useHistory()
    const {getData: fetchCards} = useCallDataApi('adventure-cards')
    const [adventureCard, setSportCard] = useState({})
    const [loading, setLoading] = useState(false)

    const params = useParams()

    useEffect(() => {
        setLoading(true)
        fetchCards(`${params?.id}/`).then(r => {
            setSportCard(r)
        }).finally(() => setLoading(false))
    }, [])

    document.title = `Jet Travel | ${adventureCard?.translations?.[language]?.name}`



    return <DrawerAppbar fade>
        <HeroImage logo={logo} title={adventureCard?.translations?.[language]?.name} underlineColor='#ff0000' image={adventureCard?.image}/>
        <div style={{marginBottom: '64px'}}>

            <Box sx={{margin: 3, display: 'flex', gap: 2}}>
                <Button onClick={() => history.goBack()} variant='outlined' startIcon={<ArrowBackIosNewRoundedIcon/>}>{t('general.back')}</Button>
            </Box>
            <Container>
                <div dangerouslySetInnerHTML={{ __html: adventureCard?.translations?.[language]?.description }}/>
            </Container>
        </div>
        <Footer />

        <Loading isLoading={loading}/>
    </DrawerAppbar>
}

export default AdventureCard